import ReactDOM from "react-dom";
import "../css/Tooltip.css";
import { Tooltip } from "react-tooltip";

export default function TooltipBox({ id, content }) {
  return ReactDOM.createPortal(
    <Tooltip id={id} opacity={1} noArrow={true} className="tooltip">
      {content}
    </Tooltip>,
    document.body
  );
}
